module.exports = __webpack_public_path__ + "img/cooler.dcd95a81.png";